import * as S from './styled';

export const SubHeader = () => {
	return (
		<S.SContainer>
			<div>
				<span>
					Ofertas → <em>Novo Série 1</em>
				</span>
				<span>
					<em>Voltar para página anterior</em>
				</span>
			</div>
			<div>
				<h1>BMW Série 4 Cabrio</h1>
			</div>
		</S.SContainer>
	);
};
